import React from 'react'

function Template() {
    return null
}

export default Template